import sentryService from '@/js/common/plugins/logger';
import { SentrySeverity } from '@travelata-libs/utils';
import { LeadBannerPayload } from '@travelata-libs/ui-shared';
import axios from 'axios';
declare let window: { appConfig: { apiGatewayUrl: string } };
export const createLead = async (data: LeadBannerPayload) => {
    try {
        const response = await axios({
            url: `${window.appConfig.apiGatewayUrl}/frontend/leads`,
            method: 'POST',
            data: data,
            timeout: 30000,
            headers: {
              'Content-type': 'application/json; charset=utf-8',
            },
        });
        response.data;
        if(!response.data.success) {
            throw new Error('api-gateway/frontend/leads success false');
        }
    } catch (error) {
        const message = error instanceof Error ? error.message : 'Неизвестная ошибка';
        sentryService.captureMessage(`Ошибка создания лида api-gateway/frontend/leads: ${message}`, SentrySeverity.Error);
        throw new Error(message);
    }
}